// extracted by mini-css-extract-plugin
export default {"wrapper":"TranscriptsTab_wrapper__tu8aZ","headerSectionWrapper":"TranscriptsTab_headerSectionWrapper__29wh5","title":"TranscriptsTab_title__TiAK5","ell":"TranscriptsTab_ell__RnouF"};